/**
 * Decodifica el payload de un JWT sin verificar la firma (solo lectura de exp).
 * Útil para comprobar en cliente si el token está expirado y evitar peticiones con token caducado.
 * @param {string} token - Token JWT
 * @returns {object|null} Payload decodificado o null si el token es inválido
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.trim().split('.');
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padding = '==='.slice(0, (4 - (base64.length % 4)) % 4);
    const decoded = atob(base64 + padding);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * Comprueba si un token JWT está expirado según el claim 'exp' (Unix timestamp en segundos).
 * Si el token es inválido o no tiene exp, se considera expirado por seguridad.
 * @param {string} token - Token JWT
 * @param {number} [leewaySeconds=0] - Segundos de margen (opcional)
 * @returns {boolean} true si está expirado o inválido, false si aún es válido
 */
export function isTokenExpired(token, leewaySeconds = 0) {
  const payload = decodeJwtPayload(token);
  if (!payload || payload.exp == null) return true;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now + leewaySeconds;
}
